<template>
  <a
    href="#"
    role="button"
    class="beamerTrigger"
    data-heap="beamer-sidepanel-icon-clicked"
    @click.prevent="openPanel"
  >
    <span class="fa fa-bullhorn" data-testid="bullhorn-icon"></span>
  </a>
</template>

<script setup lang="ts">
import { openBeamerPanel } from '../open-beamer-panel'

const props = defineProps<{ fallbackUrl?: string }>()

const openPanel = () => openBeamerPanel(props.fallbackUrl)
</script>

<style>
/* stylelint-disable selector-class-pattern */

/* Not scoped: Beamer SDK injects elements outside this component's subtree.
   Scoped styles cannot reach those injected nodes. */

.beamerTrigger {
  position: relative;
}

/* BEGIN OLD LAYOUT ONLY — old layout renders <a class="beamerTrigger"> via
   BeamerWhatsNewButton Vue component. Remove once old layout is retired. */
a.beamerTrigger .beamer_icon {
  top: 8px !important;
  right: 8px !important;
  min-width: 8px !important;
  width: 8px !important;
  height: 8px !important;
  padding: 0 !important;
  border-radius: 50% !important;
  font-size: 0 !important;
  line-height: 0 !important;
}

/* END OLD LAYOUT ONLY */

button.beamerTrigger .beamer_icon {
  top: -4px !important;
  right: -4px !important;
  min-width: 8px !important;
  width: 8px !important;
  height: 8px !important;
  padding: 0 !important;
  border-radius: 50% !important;
  font-size: 0 !important;
  line-height: 0 !important;
}
/* stylelint-enable selector-class-pattern */
</style>
